// extracted by css-extract-rspack-plugin
export default {"topBar":"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__topBar-vxULSw","appItem":"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__appItem-H4NJdc","appIcon":"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__appIcon-vsH4s5","appLabel":"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__appLabel-y13qze","userSection":"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__userSection-W7Bhbt"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"topBar\":\"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__topBar-vxULSw\",\"appItem\":\"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__appItem-H4NJdc\",\"appIcon\":\"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__appIcon-vsH4s5\",\"appLabel\":\"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__appLabel-y13qze\",\"userSection\":\"src-modules-desktop-components-AppSessionTopBar-AppSessionTopBar-module__userSection-W7Bhbt\"}";
        // 1793872696644
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  